import { render, staticRenderFns } from "./synchronization.vue?vue&type=template&id=fc708f3c&"
import script from "./synchronization.vue?vue&type=script&lang=js&"
export * from "./synchronization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports